import { createReactHook, createStore } from '@alinnert/tstate'
import { ApiPortalData } from 'sfportal_services_api/apiSchemas'
import { RequestStatus } from 'sfportal_services_api/generic/types'
import { apiGetPortalData } from 'sfportal_services_api/portaldataApiService'
import { setStorageValue } from '../services/localStorageService'
import { handleRequestError } from './allStores'

/**
 * @file Dieser Store enthält die Daten vom Portal, die über den API-Aufruf
 * `GET /portaldata` geladen werden.
 */

// #region store
interface PortalDataStore {
  data: ApiPortalData | null
  status: RequestStatus
}

function getInitialState (): PortalDataStore {
  return { data: null, status: RequestStatus.ok }
}

const store = createStore(getInitialState())
export const usePortalDataStore = createReactHook(store)

const mutations = {
  startLoading (): void {
    store.set({ status: RequestStatus.pending })
  },

  setPortalData (data: PortalDataStore['data']): void {
    if (data !== null) {
      setStorageValue('portal-data:data', data)
    }
    store.set({ data, status: RequestStatus.ok })
  },

  setStatus (status: RequestStatus): void {
    store.set({ status })
  }
}
// #endregion store

// #region actions
export async function loadPortalData (): Promise<void> {
  mutations.startLoading()

  try {
    const { body } = await apiGetPortalData()
    mutations.setPortalData(body)
  } catch (error) {
    mutations.setStatus(handleRequestError(error))
  }
}
// #endregion actions
